module.exports = __webpack_public_path__ + "img/med-max.d46092e7.svg";